import { ContainerComment, Subtitle } from '../DetailsRoomsBathrooms/styles';
import InverterTable from '../InverterTable/InverterTable';
import { dictionaryGoodZoneTableCo } from './utils';
import { organizeData } from '../DetailHistoricalBusinnesInformation/utils';
import { useSelector } from 'react-redux';

const DetailGoodZone = () => {
  const stateCards = useSelector((state: any) => state.cardsStore.stateCards);

  const dataGoodZone = stateCards.filter((item: any) => item.id === 6);

  const approvalData = dataGoodZone[0]?.table?.approval_result;
  const tableData = approvalData?.table_data;
  const approvalResult = approvalData?.approval_result ?? '';
  const rejectedCount = approvalData?.rejected;
  const approvedCount = approvalData?.approved;

  const handleOrderData = organizeData(tableData, dictionaryGoodZoneTableCo);

  const handleCreateComment = (
    approval_result: string,
    rejected: string = '-',
    approved: string = '-'
  ) => {
    switch (approval_result) {
      case 'approved':
        return `OK - Se aprueba ya que se ha aprobado la zona en ${approved} aprobaciones`;
      case 'rejected':
        return `RECHAZADO - Se rechaza ya que se tienen ${rejected} rechazos en la zona por motivos inherentes a la zona`;
      case 'warning':
        return `REVISAR - No se tiene experiencia en la zona en los últimos 6 meses`;
      default:
        return '';
    }
  };
  return (
    <>
      {tableData?.length > 0 ? (
        <>
          <ContainerComment>
            <div className="title">Comentario: </div>
            <div className="subtitle">
              {handleCreateComment(approvalResult, rejectedCount, approvedCount)}
            </div>
          </ContainerComment>
          <Subtitle>Información para aprobación de zona</Subtitle>
          <InverterTable data={handleOrderData} />
        </>
      ) : (
        <ContainerComment>
          <div className="title">Comentario: </div>
          <div className="subtitle">No se encontraron datos</div>
        </ContainerComment>
      )}
    </>
  );
};

export default DetailGoodZone;
